import {showCatalogPopup} from "./show-catalog-popup";
import {RenderPosition, render} from "./utils/render";
import HeaderLightComponent from "./components/header-light-component";
import MenuLightController from "./controllers/menu-light-controller";


export const renderHeaderLight = (shopInfoData, logoData, catalogList) => {
  const container = document.querySelector(`.main-header`);
  if (!container) {
    return;
  }

  let menuController = null;

  const component = new HeaderLightComponent({logo: logoData});
  render(container, component.getElement(), RenderPosition.BEFOREEND);


  // обработчик скролла
  window.addEventListener(`scroll`, (evt) => {
    const scroll = evt.target.scrollingElement.scrollTop;
    if (scroll >= 200) {
      container.classList.add(`main-header--scroll`);
    } else {
      container.classList.remove(`main-header--scroll`);
    }
  });

  const onHideModalHanlder = component.onHideMenuHandler;
  // клик на бургер
  component.setBurgerButtonClickHanlder((isShowMenu) => {
    if (isShowMenu) {
      menuController = new MenuLightController({shopInfoData, logoData, catalogList, onHideModalHanlder});
      menuController.show();
    } else {
      if (menuController) {
        menuController.hide();
      }
      menuController = null;
    }
  });

  // клик по кнопка Каталога
  component.setCatalogButtonClickHandler(() => {
    showCatalogPopup(logoData, catalogList);
  });
};
